const RELAY_DOMAINS = ['@privaterelay.appleid.com', '@icloud.com'];

export const isPrivateRelayEmail = (email?: string) => {
  if (!email) return false;
  return RELAY_DOMAINS.some((domain) => email.endsWith(domain));
};
